// Copyright 2021-2022 zcloak authors & contributors
// SPDX-License-Identifier: Apache-2.0

import { Box, Button, TextField } from '@mui/material';
import { useCallback, useMemo, useState } from 'react';

import { usePhase } from '../../hooks/usePhase';
import IconFail from '../verify/icon_fail.svg';
import IconEth from './icon_eth.png';
import IconSuccess from './icon_success.svg';

const EthInput: React.FC<{
  disable: boolean;
  submitEth: (ethAddr?: string) => void;
  text: string;
}> = ({ disable, submitEth, text }) => {
  const [ethAddr, setEth] = useState<string>('');
  const [errorText, setErrorText] = useState<string>();
  const phases = usePhase();

  const isSubmitted = useMemo(() => {
    if (phases?.[3] === true) {
      return true;
    } else {
      return false;
    }
  }, [phases]);

  const confirm = useCallback(() => {
    if (ethAddr?.length !== 42) {
      setErrorText('Please input a valid eth address.');
    } else {
      submitEth(ethAddr);
    }
  }, [ethAddr, submitEth]);

  return (
    <Box
      sx={{
        marginTop: '30px',
        display: 'flex'
      }}
    >
      <img height={44} src={IconEth} width={44} />
      {disable || isSubmitted ? (
        <Box
          sx={{
            width: '100%',
            height: '44px',
            display: 'flex',
            color: isSubmitted ? '#41CC8B ' : '#E8363E',
            fontSize: '12px',
            alignItems: 'center',
            background: '#E4EEEF',
            paddingLeft: '20px',
            marginLeft: '20px',
            marginRight: '20px',
            borderRadius: '10px',
            img: {
              marginRight: '10px'
            }
          }}
        >
          {isSubmitted ? (
            <>
              <img height={20} src={IconSuccess} width={20} />
              You have bound your ETH address successfully!
            </>
          ) : (
            <>
              <img height={20} src={IconFail} width={20} />
              {text}
            </>
          )}
        </Box>
      ) : (
        <TextField
          error={errorText ? true : undefined}
          helperText={errorText}
          onChange={(e) => {
            setErrorText(undefined);
            setEth(e.target.value);
          }}
          placeholder="ETH address"
          size="small"
          sx={{
            width: '100%',
            marginLeft: '20px',
            marginRight: '20px'
          }}
          value={ethAddr}
        />
      )}
      <Button disabled={disable || isSubmitted} onClick={confirm} variant="contained">
        Submit
      </Button>
    </Box>
  );
};

export default EthInput;
